import { Action } from '@ngrx/store';

export class SuitabilityBypassAgreementActions implements Action {
    public static getSuitabilityBypassAgreement: string = '[SUITABILITY_BYPASS_AGREEMENT] GET_SUITABILITY_BYPASS_AGREEMENT';
    public static getSuitabilityBypassAgreementError: string = '[SUITABILITY_BYPASS_AGREEMENT] GET_SUITABILITY_BYPASS_AGREEMENT_ERROR';
    public static getSuitabilityBypassAgreementSuccess: string = '[SUITABILITY_BYPASS_AGREEMENT] GET_SUITABILITY_BYPASS_AGREEMENT_SUCCESS';

    public static updateSuitabilityBypassAgreement: string = '[SUITABILITY_BYPASS_AGREEMENT] UPDATE_SUITABILITY_BYPASS_AGREEMENT';
    public static updateSuitabilityBypassAgreementError: string = '[SUITABILITY_BYPASS_AGREEMENT] UPDATE_SUITABILITY_BYPASS_AGREEMENT_ERROR';
    public static updateSuitabilityBypassAgreementSuccess: string = '[SUITABILITY_BYPASS_AGREEMENT] UPDATE_SUITABILITY_BYPASS_AGREEMENT_SUCCESS';
    
    constructor(
        public type: string,
        public payload?: any
    ) {}
}
